import { LocationInputV2 } from '@shared/components/LocationInputV2';
import { LocationInputV2Response } from '@shared/components/LocationInputV2/LocationInputV2.types';
import { FormControl } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { useField } from 'formik';
import React from 'react';
import * as Yup from 'yup';

const schema = Yup.object({
  displayName: Yup.string(),
  latitude: Yup.number(),
  longitude: Yup.number()
}).test('location', 'Invalid location', function (value) {
  if (!value) {
    return false;
  }
  return value.displayName && value.latitude && value.longitude;
});
type ISchema = {
  displayName: string;
  latitude: number;
  longitude: number;
};

const initialValue = {
  displayName: '',
  latitude: undefined,
  longitude: undefined
};

const Fields = ({ fieldsId }: { fieldsId: string }) => {
  // avoid passing value because I want LocationInputV2 to be an uncontrolled component, we just want the location info
  const [{ value, ...restField }, meta, helper] = useField<Partial<ISchema>>(fieldsId);
  const onChange = (response: LocationInputV2Response | null) => {
    if (!response) {
      return;
    }
    helper.setValue({
      displayName: response.displayName,
      latitude: response.lat,
      longitude: response.lng
    });
  };
  // meta.error is not a string, it's an object but formik doesn't realize that
  const errorMessage = (meta.touched && meta.error) || undefined;
  return (
    <FormControl {...meta} maxWidth={[pxToRem(260)]} position={'absolute'} top={0} isInvalid={!!errorMessage} error={errorMessage}>
      <LocationInputV2
        {...restField}
        includeMapIcon
        iconRight={null}
        noBorder
        placeholder="Center Park Boathouse"
        placePredictionTypes={[]}
        isHideIcon={true}
        defaultValue={value.displayName}
        onLocationChange={onChange}
        includeHotelIcon={false}
      />
    </FormControl>
  );
};

export { Fields, schema, initialValue };
